import { addClickEventForBookServiceButton } from "./addClickEventForBookServiceButton";
import { addServiceMoreButtonClickEvent } from './addServiceMoreButtonClickEvent'
import { updateSelectedServices } from "./updateSelectedServices";

const enumBookingProgressStep = {
  SERVICE: 0,
  DATE: 1,
  SUMMARY: 2,
}
let bookingProgressStep = enumBookingProgressStep.LOGIN;

document.addEventListener("DOMContentLoaded", function (event) {
  // TODO: update the system test and refactor this file.

  setInitialBookingStep();
  // Take the user to the date page if url contains a service name
  const url = new URL(window.location.href);
  const serviceName = url.searchParams.get("service_name");
  if (serviceName) {
    let serviceInput = document.querySelector('[name="services"]');
    serviceInput.value = serviceName.concat(', ');
    changeBookingStep(enumBookingProgressStep.DATE);
    updateSelectedServices();
  }

  addServiceMoreButtonClickEvent();

  // validate the Service booking step and move to the Location
  addClickEventForBookServiceButton();

  // validate the Location booking step and move to the Date
  let locationButtons = document.querySelectorAll('.location-button');
  locationButtons.forEach((e) => {
    e.addEventListener('click', validateLocationStep);
  });

  // validate the Date booking step and move to the Summary
  let goToSummaryButton = document.getElementById('goToSummaryButton');
  goToSummaryButton.addEventListener("click", validateDateStep);

  // Change the booking step when clicking on the progress bar
  let bookingStepNavButton = document.querySelectorAll('.bookingStep-navButton');
  bookingStepNavButton.forEach((e) => { e.addEventListener('click', changeProgressOption) });

  // validate the entire form and submit it
  // add code here...

  const appointmentForm = document.getElementById('appointmentForm');
  appointmentForm.addEventListener('submit', validateForm);

  updateAppointmentView();
});

function updateAppointmentView() {
  displayCurrentInfoSlide()
  updateBookingProgressBar()
}

function changeProgressOption() {
  bookingProgressStep = this.dataset.bookingStep
  updateBookingProgressBar();
  displayCurrentInfoSlide();
}

function changeBookingStep(step) {
  window.scrollTo(0,0)
  bookingProgressStep = step;
  updateAppointmentView()
}

function updateBookingProgressBar() {
  for (let i = bookingProgressStep; i <= 2; i++) {
    let stepComplete = document.querySelector(`[data-booking-step="${i}"]`);
    stepComplete.classList.remove('bookingProgressionBar-done')
    stepComplete.classList.remove('bookingProgressionBar-selected')
  }
  for (let i = 0; i < bookingProgressStep; i++) {
    let stepComplete = document.querySelector(`[data-booking-step="${i}"]`);
    if (!stepComplete) { continue }
    stepComplete.classList.add('bookingProgressionBar-done')
    stepComplete.classList.remove('bookingProgressionBar-selected')
  }
  let currentStep = document.querySelector(`[data-booking-step="${bookingProgressStep}"]`);
  currentStep.classList.add('bookingProgressionBar-selected')
  currentStep.classList.remove('bookingProgression-done')
}

function displayCurrentInfoSlide() {
  let slides = document.querySelectorAll('[data-appointment-info-slide]');
  slides.forEach((e) => {
    e.classList.remove('d-block')
    e.classList.add('d-none');
  })

  let currentSlide = document.querySelector(`[data-appointment-info-slide="${bookingProgressStep}"]`);
  currentSlide.classList.add('d-block');
  currentSlide.classList.remove('d-none');
}

export function validateServiceStep() {
  window.scrollTo(0, 0);
  // Isn't currently used, and this will be changed when updating to Vue3.
  // let goToSummaryButton = document.getElementById('goToSummaryButton');
  // goToSummaryButton.href = `/recommendations/${this.id}`;
  let serviceInput = document.querySelector('[name="services"]');

  if (bookingProgressStep == enumBookingProgressStep.SERVICE) {
    serviceInput.value = this.id.concat(', ');
    changeBookingStep(enumBookingProgressStep.DATE);
  } else if (bookingProgressStep == enumBookingProgressStep.DATE) {
    serviceInput.value += this.id.concat(', ')
  }
  updateSelectedServices();
}

function validateLocationStep() {
  let serviceInput = document.querySelector('[name="location"]');
  serviceInput.value = this.id;
  let dataAppointmentInfo = document.querySelectorAll(`[data-appointment-info="location"]`);
  dataAppointmentInfo.forEach((e) => { e.innerHTML = this.id });

  // check validation
  changeBookingStep(enumBookingProgressStep.DATE)
}

function validateDateStep() {
  // check validation
  const errorContainer = document.getElementById('errorContainer');
  const timeSlotInput = document.querySelector('input[name="time_slot"]');
  const dateInput = document.querySelector('input[name="date"]');
  window.scrollTo(0,0);

  const finalSummaryContainer = document.getElementById('finalSummaryContainer');
  const closeButtons = finalSummaryContainer.querySelectorAll('.service-closeButton')
  closeButtons.forEach((closeButton) => {
    closeButton.remove();
  })

  if (timeSlotInput.value === "" && dateInput.value === "") {
    errorContainer.innerHTML = "<p class='validation-text'>Please select a date and time</p>";
    return;
  } else if (timeSlotInput.value === "") {
    errorContainer.innerHTML = "<p class='validation-text'>Please select a time</p>";
    return;
  } else {
    errorContainer.innerHTML = "";
  }

  changeBookingStep(enumBookingProgressStep.SUMMARY)
}

function setInitialBookingStep() {
  let initialBookingStep = document.getElementById('initialBookingStep').dataset.initialBookingStep;
  if (initialBookingStep == enumBookingProgressStep.LOGIN) {
    changeBookingStep(enumBookingProgressStep.LOGIN)
    let loginNext = document.getElementById('loginNext');
    loginNext.addEventListener("click", validateLoginStep);
  } else {
    changeBookingStep(enumBookingProgressStep.SERVICE)
  }
}

function validateForm(event) {
  event.preventDefault();

  let email = document.querySelector('[name="email"]').value;
  if (!email) { return }

  let tokenNode = document.querySelector('meta[name="csrf-token"]');
  const TOKEN = (tokenNode) ? tokenNode.getAttribute('content') : null;
  const url = `/check_email?email=${encodeURIComponent(email)}`;

  fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'applicaton/json',
      'Accept': 'applicaton/json',
      'X-CSRF-Token': TOKEN,
    }
  }).then(response => {
    if (!response.ok) {
      throw new Error('There was a problem with the request.')
    }
    return response.json();
  }).then(data => {
    let postcode = document.querySelector('[name="postcode"]');
    let serviceLocation = document.querySelector('[name="service_location"]');

    console.log(postcode)
    console.log(serviceLocation)

    if (data['existing_appointment'] || serviceLocation.value == 'Online' || postcode?.value) {
      event.target.submit();
    } else {
      const emailError = document.getElementById('emailError');
      emailError.innerHTML = "<p class='validation-text'>Email address hasn't been found. Click here to enter detail.</p>";
    }
  }).catch((error) => {
    console.log('error: ', error);
  });
}
